export default "__VITE_ASSET__CCwqCW$K__"